

/// <reference path="DBDocumentLine.ts" />

// Generated class QuotationDocumentLine_ManagedObject

class QuotationDocumentLine_ManagedObject extends DBDocumentLine
{
}
